import React from 'react';
import { Checkbox } from 'antd';
import Cell from '../Cell';

const CheckboxCell = ({ placement, checked, indeterminate, onClick }) => {
  return (
    <Cell placement={placement} column={1} type="checkbox">
      <Checkbox
        checked={checked}
        onClick={onClick}
        indeterminate={indeterminate}
      />
    </Cell>
  );
};

export default CheckboxCell;
